import moduleDescriptions from 'root/src/shared/descriptions/modules'
import { listModuleLenses } from 'root/src/client/logic/list/lenses'

const { viewDefaultListDataLength } = listModuleLenses

export default (state, { moduleId }) => viewDefaultListDataLength(moduleId, moduleDescriptions)
